import { customLocalStorage } from '@crehana/utils';

const FLOATING_SHOPPING_CART_REMINDER_KEY =
  'CREHANA__FloatingShoppingCartReminderVisibility';

export function allowFloatingShoppingCartReminderVisibility() {
  customLocalStorage.removeItem(FLOATING_SHOPPING_CART_REMINDER_KEY);
}

export default allowFloatingShoppingCartReminderVisibility;
